import type { NudgeStatus } from '../../../types/enums'

type BadgeConfig = {
  label: string
  modifier: string
  pulse?: boolean
}

const CONFIG: Record<NudgeStatus, BadgeConfig> = {
  PENDING:        { label: 'Pending',        modifier: 'pill-pending' },
  AI_PROCESSING:  { label: 'Generating…',    modifier: 'pill-sent',   pulse: true },
  AI_READY:       { label: 'Ready to Send',  modifier: 'pill-sent' },
  SENDING:        { label: 'Sending…',       modifier: 'pill-lapsed', pulse: true },
  SENT:           { label: 'Sent',           modifier: 'pill-sent' },
  FAILED:         { label: 'Failed',         modifier: 'pill-failed' },
  REPLY_RECEIVED: { label: 'Reply Received', modifier: 'pill-reply-received' },
  CONV_ACTIVE:    { label: 'In Conversation',modifier: 'pill-conv-active' },
  RECOVERED:      { label: 'Recovered',      modifier: 'pill-recovered' },
  RETURNED:       { label: 'Returned',       modifier: 'pill-returned' },
  NO_SHOW:        { label: 'No Show',        modifier: 'pill-no-show' },
  OPT_OUT:        { label: 'Opted Out',      modifier: 'pill-opt-out' },
  EXHAUSTED:      { label: 'Exhausted',      modifier: 'pill-exhausted' },
}

export function NudgeStatusBadge({ status }: { status: NudgeStatus }) {
  const { label, modifier, pulse } = CONFIG[status]
  return (
    <span className={`pill ${modifier}${pulse ? ' pill-pulse' : ''}`}>
      {label}
    </span>
  )
}
